import DeleteGenericModal from "../../modals/DeleteGenericModal";
import ReactTable from "../../util/ReactTable";
import AsyncBlock from "../../components/forms/AsyncBlock";
import PageTitle from "../../components/layout/PageTitle";
import PageSection from "../../components/layout/PageSection";
import Button from "../../components/forms/Button";
import PageContainerFull from "../../components/layout/PageContainerFull";
import {useCallback, useMemo} from "react";
import {FlexLayout} from "../../components/flex/Flex";
import useDeleteModal from "../../modals/useDeleteModal";
import axios from "axios";
import useFetch2 from "../../hooks/useFetch2";
import {Apis} from "../../util/data";
import {useNavigate} from "react-router-dom";
import * as React from "react";
import useEditModal from "../../modals/useEditModal";
import UploadConsejeria from "../../components/UploadConsejeria";
import GenericModal2 from "../../modals/GenericModal2";

const ConsejeriaList = () => {

  const navigate = useNavigate()
  const {loading, data, fetchData, error} = useFetch2(Apis.PROD + '/consejeria/list', []);

  const deleteElement = id => axios.delete(Apis.PROD + '/consejeria/' + id)

  const {
    wrapper: wrapper1,
    openDeleteModal
  } = useDeleteModal({
    text: '¿Desea eliminar esta consejeria?',
    action: deleteElement,
    onRefresh: fetchData
  })

  const {wrapper: wrapper2, editAction} = useEditModal({
    editComponent: <UploadConsejeria />,
    onRefresh: fetchData
  });

  function addConsejeria() {
    navigate('/consejerias/new')
  }

  function editConsejeria(item) {
    navigate('/consejerias/edit/' + item.id)
  }

  const boolValue = useCallback(cell => cell.renderValue()? 'V' : 'F', []);

  const actionsValue = useCallback(cell =>
      <FlexLayout justifyContent='center'>
        <Button size='xs' variant='light' onClick={() => editConsejeria(cell.row.original)}>Editar</Button>
        <Button size='xs' variant='danger' onClick={() => openDeleteModal(cell.row.original.id)}>Eliminar</Button>
        <Button size='xs' variant='light' onClick={() => editAction({id: cell.row.original.id, url: cell.row.original.url})}>Foto</Button>
      </FlexLayout>
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , []);

  const columns = useMemo(
    () => [
      {
        header: 'Codigo',
        accessorKey: 'codigo'
      },
      {
        header: 'Nombre',
        accessorKey: 'nombre',
      },
      {
        header: 'Presentacion',
        accessorKey: 'presentacion',
      },
      {
        header: 'Descripcion',
        accessorKey: 'descripcion',
      },
      {
        header: 'Precio',
        accessorKey: 'precio',
        meta: {
          headerClassName: 'text-center', // class para la cabecera
          columnClassName: 'text-center', // class para la columna
        },
      },
      {
        header: 'Porcentaje desc.',
        accessorKey: 'porcDesc',
        meta: {
          headerClassName: 'text-center', // class para la cabecera
          columnClassName: 'text-center', // class para la columna
        },
      },
      {
        header: 'Activo',
        accessorKey: 'activo',
        meta: {
          headerClassName: 'text-center', // class para la cabecera
          columnClassName: 'text-center', // class para la columna
        },
        cell:boolValue
      },
      {
        header: 'Acciones',
        accessorKey: 'id',
        meta: {
          headerClassName: 'text-center', // class para la cabecera
          columnClassName: 'text-center', // class para la columna
        },
        enableSorting: false, // para deshabilitar el sort
        cell: actionsValue
      }
    ]
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , [data]
  )

  return (
    <PageContainerFull>

      <PageSection>
        <PageTitle title={'Consejerias'}/>

        <AsyncBlock loading={loading} error={error}>
          <ReactTable
            columns={columns}
            data={data || []}
            customSearch
            filterAdd={() => addConsejeria()}
            noData='No existen consejerias'
            pageSize={20}
          />
        </AsyncBlock>
      </PageSection>
      <DeleteGenericModal {...wrapper1} />
      <GenericModal2 {...wrapper2} />
    </PageContainerFull>
  )
}

export default ConsejeriaList
